import { jsxs as n, jsx as i } from "react/jsx-runtime";
import { VStack as b } from "@chakra-ui/react";
import { FileListItem as u } from "../FileListItem/FileListItem.mjs";
import f from "./FileUploadAllButton.mjs";
const j = ({
  "data-testid": l,
  files: $ = [],
  hideFileActionButtons: c,
  hideUploadAllButton: a,
  id: e,
  name: o,
  onRemoveFile: m,
  onUploadAllClick: s
}) => {
  let t = { above: !0, below: !0 };
  return typeof a == "boolean" && a === !1 ? t = { ...t, below: !1 } : typeof a == "object" && (t = a), /* @__PURE__ */ n(b, { spacing: 4, alignItems: "start", children: [
    !t.above && /* @__PURE__ */ i(
      f,
      {
        id: e && `${e}-uploadall-above`,
        name: o && `${o}-uploadall-above`,
        "data-testid": l && `${l}-uploadall-above`,
        onClick: s
      }
    ),
    /* @__PURE__ */ i(b, { spacing: 0, align: "stretch", width: "100%", role: "list", children: $.map((r, p) => /* @__PURE__ */ i(
      u,
      {
        onRemoveFile: m,
        ...r,
        id: e && `${e}-file${p}`,
        name: o && `${o}-file${p}`,
        "data-testid": l && `${l}-file${p}`,
        ...c && { hideActionButton: !0 }
      },
      r.key ?? r.file.name
    )) }),
    !t.below && /* @__PURE__ */ i(
      f,
      {
        id: e && `${e}-uploadall-below`,
        name: o && `${o}-uploadall-below`,
        "data-testid": l && `${l}-uploadall-below`,
        onClick: s
      }
    )
  ] });
};
export {
  j as FileList
};
